import React from 'react'
import { Card, Skeleton, Tabs } from 'antd'
import type { TabsProps } from 'antd'

const DashboardSkeleton: React.FC = () => {
  const skeletonTabItems: TabsProps['items'] = [
    {
      key: 'pending',
      label: <Skeleton.Input style={{ width: 150, height: 20 }} active size="small" />,
      children: (
        <div style={{ padding: '20px 0' }}>
          {/* Two skeleton tiles for pending requests */}
          <Skeleton active paragraph={{ rows: 2 }} />
        </div>
      ),
    },
    {
      key: 'scheduled',
      label: <Skeleton.Input style={{ width: 150, height: 20 }} active size="small" />,
      children: (
        <div style={{ padding: '20px 0' }}>
          {/* Two skeleton tiles for scheduled leaves */}
          <Skeleton active paragraph={{ rows: 2 }} />
        </div>
      ),
    },
  ]

  return (
    <>
      {/* Filter Skeleton */}
      <div className="dashboard-filters dashboard-width" style={{ marginBottom: 16 }}>
        <Skeleton.Button style={{ width: 80, height: 32 }} active />
      </div>

      {/* Heatmap Card - Single full-width tile + leave list */}
      <Card className="heatmap dashboard-width" style={{ marginBottom: 16 }}>
        <Skeleton.Button 
          style={{ 
            width: '100%', 
            height: 200,
            marginBottom: 12,
          }} 
          active
          block
          size="large"
        />

        <Skeleton.Button
          style={{
            width: '100%',
            height: 66,
            marginBottom: 12,
          }}
          active
          block
          size="large"
        />

        <Skeleton.Button
          style={{
            width: '100%',
            height: 225,
          }}
          active
          block
          size="large"
        />
      </Card>

      {/* Leave Tabs Card */}
      <Card className="dashboard-leaves-info dashboard-width">
        <Tabs defaultActiveKey="pending" items={skeletonTabItems} />
      </Card>
    </>
  )
}

export default React.memo(DashboardSkeleton) 